<button [attr.data-testid]="dataTestId()" mat-button="tonal" class="tonal-button" (click)="onClick($event)">
  <mat-icon [svgIcon]="icon()"></mat-icon>
  @if (counter() > 0) {
    {{ counter() }} {{ buttonText() }}
  } @else {
    {{ buttonText() }}
  }
</button>
